<template>
	<form id="role-form" :action="'/users/update-current-role/'+props.user.id" method="POST">
		<input type="hidden" name="_token" :value="csrf">

		<div class="form-check form-check-inline">
		  	<input class="form-check-input" type="radio" id="consultantRoleRadio" name="role_id" v-model="currentRoleId" :value="props.consultantRole.id" @change.once="switchRole">
		  	<label class="form-check-label" for="consultantRoleRadio">Consultant</label>
		</div>
		<div class="form-check form-check-inline">
		  	<input class="form-check-input" type="radio" id="doulaRoleRadio" name="role_id" v-model="currentRoleId" :value="props.doulaRole.id" @change.once="switchRole">
		  	<label class="form-check-label" for="doulaRoleRadio">Doula</label>
		</div>

	</form>
</template>

<script setup>
	import { ref } from 'vue'
    const props = defineProps(['user', 'consultantRole', 'doulaRole'])
    const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    const currentRoleId = ref(props.user.current_role_id)

	function switchRole(roleId) {
		if (roleId != currentRoleId) {
    		document.getElementById("role-form").submit();
    	}
	}
</script>